import { render, staticRenderFns } from "./HeatmapTableWidget.vue?vue&type=template&id=52782f15&scoped=true"
import script from "./HeatmapTableWidget.vue?vue&type=script&lang=ts"
export * from "./HeatmapTableWidget.vue?vue&type=script&lang=ts"
import style0 from "./HeatmapTableWidget.vue?vue&type=style&index=0&id=52782f15&prod&lang=scss&scoped=true"
import style1 from "./HeatmapTableWidget.vue?vue&type=style&index=1&id=52782f15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52782f15",
  null
  
)

export default component.exports